import React, { Component } from 'react';
import {Link}from 'react-router-dom';

// images

import InfoJumb1 from './images/infoJumbo1.jpg';
import InfoJumb2 from './images/infoJumbo2.jpg';
import InfoJumb3 from './images/infoJumbo3.jpg';

import banner1 from './images/banner1.jpg';

import { Grid, Row, Col, Carousel, Breadcrumb, Button} from 'react-bootstrap';

class Davi extends Component {
  render() {
    return (
      <div className='container-fluid'>
        <div className="supMainLS">
          <div className="BC">
          <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >
              <Link to="/Suppliers">Lieferanten</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                <Link to="/Suppliers/SuB">SuB</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Davi</Breadcrumb.Item>
          </Breadcrumb>
          </div>
          <img src={banner1} alt="DAVI Promau Headquater"/>
        </div>
        <div className="supMainTextLS">
          <h1>DAVI</h1>
          <Grid className="supMainInfo">
            <Row>
              <Col xsHidden smHidden md={3}>
                <Carousel  controls={false} interval={3000}>
                  <Carousel.Item >
                      <img  src={InfoJumb1}  alt="DAVI Profilbiegen"  height="100%" />
                  </Carousel.Item>
                  <Carousel.Item>
                      <img  src={InfoJumb2} alt="DAVI Windturm"  height="100%"/>
                  </Carousel.Item>
                  <Carousel.Item>
                      <img  src={InfoJumb3} alt="DAVI Promau Headquater"  height="100%" />
                  </Carousel.Item>
                </Carousel>
                </Col>
              <Col xsHidden md={8}>
                <h4>DAVI-PROMAU ist seit Jahren weltweit der größte Hersteller von Rund-/Profilbiegemaschinen und automatisierter Rundbiegetechnologie. Davi ist heutzutage in einem Großteil renomierter Firmen im Bereich Kesselbau anzutreffen. Sogar im Bereich Raumfahrt ist Davi anzutreffen. Denn wer möchte nicht gerne die gleich Technik wie die NASA verwenden.</h4>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>
                <h4>DAVI-PROMAU ist seit Jahren weltweit der größte Hersteller von Rund-/Profilbiegemaschinen und automatisierter Rundbiegetechnologie.
              </h4>
              </Col>
              <Col xs={12} md={{ span: 7, offset: 2 }}>
                <Button className="supMainButtonWebPage" variant="light" href="http://www.davi.com/" target="_blank">Hersteller Homepage</Button>
              </Col>
            </Row>
          </Grid>
        </div>
        <br/>
        <section>
        <div className="supMainKeyWords">
          <br/>
          <Grid>
            <Row>
              <Col xsHidden  sm={4} md={2}>

                <h5>Hohe Qualität</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                  <h5>Marktführer im Bereich Rund-/Profilbiegen</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>100% Eigenfertigung Made in Italy</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Kooperationspartner der NASA</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Customer Care Team</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Eigene Entwicklung</h5>
              </Col>

            </Row>
            <br/>
            <Row className="show-grid">
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Customer Care Team</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Marktführer im Bereich Rund-/Profilbiegen</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Kooperationspartner der NASA</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Eigene Entwicklung</h5>
              </Col>


            </Row>
          </Grid>
          <br/>
        </div>
        </section>
        <section>
          <Grid className="gridUp">
            <center>
              <h1>Produkte</h1>
            </center>
            <Row className="show-grid">
              <Col  xs={6} sm={6}>
                <center>
                  <Link to="/Suppliers/Davi/Rundbiegen"><h4 className="buttonBlue">Rundbiegen</h4></Link>
                </center>
                </Col>
                <Col  xs={6} sm={6}>
                  <center>
                    <Link to="/Suppliers/Davi/Profilbiegen"><h4 className="buttonBlue">Profilbiegen</h4></Link>
                  </center>
                  </Col>
              </Row>
            </Grid>
            <br/>
        </section>
        </div>
    );
  }
}

export default Davi;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/davi/mainPageSup.js